module.exports = __webpack_public_path__ + "img/sign-29.4a1acf24.jpg";